import React from "react";

interface CategoryEditModalProps {
  category: null | { description: string; name: string };
  onClose: () => void;
  onSubmit: (data: any) => void;
  open: boolean;
}

const CategoryEditModal: React.FC<CategoryEditModalProps> = ({
  category,
  onClose,
  onSubmit,
  open,
}) => {
  const [form, setForm] = React.useState<{ description: string; name: string }>(
    {
      description: "",
      name: "",
    },
  );

  React.useEffect(() => {
    if (category) {
      setForm({
        description: category.description || "",
        name: category.name || "",
      });
    }
  }, [category]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(form);
  };

  if (!open || !category) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <form
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-gray-100">
          Edit Category
        </h2>
        <div className="space-y-2">
          <input
            className="mb-2 w-full rounded border px-2 py-1 dark:bg-gray-800 dark:text-gray-100"
            name="name"
            onChange={handleChange}
            placeholder="Name"
            value={form.name}
          />
          <input
            className="mb-2 w-full rounded border px-2 py-1 dark:bg-gray-800 dark:text-gray-100"
            name="description"
            onChange={handleChange}
            placeholder="Description"
            value={form.description}
          />
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            className="rounded bg-gray-400 px-4 py-2 text-white"
            onClick={onClose}
            type="button"
          >
            Cancel
          </button>
          <button
            className="rounded bg-blue-600 px-4 py-2 text-white"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default CategoryEditModal;
